export default "__VITE_ASSET__CAGBulvj__"